// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import App from './App'
import router from './router'
import VueMq from 'vue-mq'
import { store } from './store'
import vueSmoothScroll from 'vue-smooth-scroll'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VModal from 'vue-js-modal'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import moment from "moment";
import VueMomentJS from "vue-momentjs";
import LottieVuePlayer from "@lottiefiles/vue-lottie-player"
Vue.config.productionTip = false

Vue.use(vueSmoothScroll);
Vue.use(VueCookies);
Vue.use(VueAxios, axios);
Vue.use(VModal);
Vue.use(VueMq, {
	breakpoints: {
		mobile: 720,
		tablet: 768,
		laptop: Infinity,
	}
});
Vue.use(VueMomentJS, moment)
Vue.use(LottieVuePlayer)

function isIpadOS() {
	return navigator.maxTouchPoints &&
		navigator.maxTouchPoints > 2 &&
		/MacIntel/.test(navigator.platform);
}

axios.defaults.baseURL = process.env.PROTOCOL + process.env.URLAPI
$cookies.config(60 * 60 * 24 * 7, '');

var viewportWidth = 'device-width'
if (isMobileOnly) {
	viewportWidth = 720
} else if (isTablet || isIpadOS()) {
	viewportWidth = 1024
}

// document.getElementById("viewport").setAttribute("content", "width=" + viewportWidth + ", user-scalable=no");

new Vue({
	el: '#app',
	store,
	router,
	components: { App },
	template: '<App/>'
})
